import { render, staticRenderFns } from "./RelationImportUpload.vue?vue&type=template&id=33192561"
import script from "./RelationImportUpload.vue?vue&type=script&lang=js"
export * from "./RelationImportUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports